import React, { useEffect, useState } from "react";
import { useAuth } from "../../auth";
import IonRangeSlider from "react-ion-slider";
import { addAlert, updateAlert, getAlertByCustomerId } from "./request";
import axios, { AxiosError } from "axios";

// Define the type for the range items
interface RangeItem {
  from_value: number;
  to_value: number;
  name: string;
}

export function AlertSetup() {
  const [valueFrom, setValueFrom] = useState(0);
  const [valueTo, setValueTo] = useState(0);
  const { currentUser } = useAuth();
  const [alertId, setAlertID] = useState("");
  const [range, setRange] = useState<RangeItem[]>([
    { name: "Good", from_value: 0, to_value: 0 },
    { name: "Moderate", from_value: 0, to_value: 0 },
    { name: "Unhealthy if sensitive", from_value: 0, to_value: 0 },
    { name: "Unhealthy", from_value: 0, to_value: 0 },
    { name: "Very unhealthy", from_value: 0, to_value: 0 },
    { name: "Hazardous", from_value: 0, to_value: 0 },
  ]);
  const [isNewAlert, setIsNewAlert] = useState(false); // State to track new vs. existing alert


  const getAlertList = async () => {
    try {
      const { data } = await getAlertByCustomerId(currentUser.customer_id);
      if (data && data.length > 0) {
        setRange(data[0].data);
        setAlertID(data[0]._id);
        setIsNewAlert(false);
      }
    } catch (err) {
      console.log(err, "err");
  
      // Type guard for AxiosError
      if (axios.isAxiosError(err) && err.response && err.response.status === 404) {
        setIsNewAlert(true); 
      }
    }
  };
  

  const addAlertList = async () => {
    try {
      const params = {
        customer_id: currentUser.customer_id,
        data: range,
        meta: {},
      };
      await addAlert(params);
      setIsNewAlert(false); 
    } catch (err) {
      console.log(err, "err");
    }
  };

  const updateAlertList = async () => {
    try {
      const params = {
        customer_id: currentUser.customer_id,
        data: range,
        meta: {},
      };
      await updateAlert(params, alertId);
    } catch (err) {
      console.log(err, "err");
    }
  };

  useEffect(() => {
    getAlertList();
  }, []);

  const handleChange = (data: any, index: number) => {
    const newRange = [...range];
    newRange[index].from_value = data.from;
    newRange[index].to_value = data.to;
    setRange(newRange);
  };

  return (
    <div className="current-range m-b">
      <div className="">
        {range.map((item, index) => (
          <div
            className="d-flex flex-row align-items-center mt-4"
            key={item.name}
          >
            <div className="col-3">{item.name}</div>
            <div className="col-9">
              <IonRangeSlider
                type={"double"}
                min={0}
                max={500}
                from={item.from_value}
                to={item.to_value}
                step={1}
                grid={true}
                gridNum={20}
                onFinish={(data) => handleChange(data, index)}
              />
            </div>
          </div>
        ))}
      </div>
      <div className="d-flex justify-content-end mt-7 ">
        {isNewAlert ? (
          <button
            className="btn btn-primary me-4"
            style={{ marginLeft: "12px" }}
            onClick={addAlertList}
          >
            Save
          </button>
        ) : (
          <button
            className="btn btn-primary me-4"
            style={{ marginLeft: "12px" }}
            onClick={updateAlertList}
          >
            Update
          </button>
        )}
        <button className="btn btn-secondary">Cancel</button>
      </div>
    </div>
  );
}
